module.exports = __webpack_public_path__ + "img/copy_outlined_24.bddb22a1.svg";